<template>
  <span class="img_box">
    <a-popover placement="left" title>
      <template #content>
        <img :src="originSrc?originSrc:src" style="width:400px;" />
      </template>
      <a-avatar
        style="border: 1px solid #BDBDBD"
        shape="square"
        size="large"
        :src="src"
        @click="openUrl(originSrc?originSrc:src)"
      />
    </a-popover>
    <slot></slot>
  </span>
</template>
<script>
  export default {
      props: {
    // 基础类型检测 (`null` 意思是任何类型都可以)
    src: String,
    originSrc:String,
    // 多种类型
      },
    components: {
    },
    computed: {
    },
    methods: {
      openUrl(url){
        window.open(url,"_blank")
      }
    },
    mounted() {},
  }
</script>
<style scoped lang="less">
  .img_box{
    margin-right: 5px;
  }
  :deep(.ant-avatar) {
    width: 55px;
    height: 55px;
  }
</style>